import React from 'react';
import { Button, Select } from '@uclaea/react-component-library';

interface BulkActionsProps {
  bulkAction: string;
  setBulkAction: (action: string) => void;
  onSubmit: () => void;
}

const bulkActionOptions = [
  { label: 'Select Action...', id: 'none', value: '' },
  { label: 'Download Selection', id: 'download', value: 'DOWNLOAD' },
  { label: 'Check In', id: 'checkin', value: 'CHECK_IN' },
  { label: 'Undo Check In', id: 'undo', value: 'UNDO_CHECK_IN' },
];

const BulkActions: React.FC<BulkActionsProps> = ({ bulkAction, setBulkAction, onSubmit }) => (
  <div className='bulk-actions'>
    <div className='bulk-actions-select'>
      <Select
        label="Action"
        value={bulkAction}
        onChange={e => setBulkAction(e.target.value)}
        options={bulkActionOptions}
      />
    </div>
    <Button variant="primary" label="Submit" onClick={onSubmit} />
  </div>
);

export default BulkActions;
